import createQuery from "./query.js";

export default (collection, db, contentType) => {
  const wasm = createQuery(db.wasm, db, contentType, (error) => {
    throw error;
  });

  const addFields = (prefix, value, fields, values) =>
    (contentType.item || []).forEach((item) => {
      if (item.id && item.type !== "date") {
        fields.push(prefix + item.id);
        values.push(value);
      } else if (item.add2id) addFields(`${prefix + item.add2id}_`, value, fields, values);
    });

  const getFilter = (query) => {
    const searchField = [];
    const searchValue = [];
    const searchInvert = [];
    let filters = [query.filter];
    if (query.filter && Object.keys(query.filter).length === 0) filters = [];
    else if (query.filter?.$and) {
      const filter = { ...query.filter };
      const and = filter.$and;
      delete filter.$and;
      filters = (and instanceof Array ? and : [and]).concat(filter);
    }

    filters.forEach((filter) => {
      const fields = [];
      const values = [];
      const invert = [];
      if (filter.$all) addFields("", new RegExp(String(filter.$all).replace(/\*/g, "\\*"), "i"), fields, values);
      const exact = filter.__exact || query.exact;
      Object.entries(filter).forEach(([field, original], index) => {
        if (["$all", "__id", "__exact"].includes(field)) return;
        fields.push(field);
        let value = original;
        if (value && value[0] === "!") {
          invert[index] = true;
          value = value.substring(1);
        }
        if (exact) values.push(new RegExp(`^${value}$`, "i"));
        else if (value instanceof Array) values.push(new RegExp(value.join("|"), "i"));
        else if (!value) values.push("false");
        else if (value === true) values.push("true");
        else if (typeof value === "string" && ["<", ">"].includes(value[0])) values.push(value);
        else values.push(new RegExp(String(value).replace(/\*/g, "\\*"), "i"));
      });
      if (fields.length) {
        searchField.push(fields);
        searchValue.push(values);
        searchInvert.push(invert);
      }
    });
    return { searchField, searchValue, searchInvert };
  };

  collection.on("search", 1000, (query) => {
    if (query.data !== undefined) return;
    query.sortby = query.sortby || "_chdate";
    query.position = query.position || 0;
    query.count = query.count || 200;
    const result = wasm.search(query, getFilter);
    if (!result) throw new Error(`Query is not supported by ${contentType.storage}: ${JSON.stringify(query.filter)}`);
    Object.assign(query, result);
  });
};
